export const referFriendStoreKey = 'referFriend';
